$(document).ready(() => {
  const $window = $(window);

  let hasScrolledBelowFold = false;
  let viewportHeight = $window.height();
  const onScrollBelowFold = () => {
    if (hasScrolledBelowFold || $window.scrollTop() < viewportHeight) {
      return;
    }

    hasScrolledBelowFold = true;
    CustomLandingPageEvent('article_below_fold_viewed', page_info.landing_page.pretty_name, page_info.landing_page.variant_name).send();
  };

  let hasScrolledHalfway = false;
  let halfwayHeight = Math.trunc($(document).height() / 2);
  const onScrollHalfway = () => {
    if (hasScrolledHalfway || $window.scrollTop() < halfwayHeight) {
      return;
    }

    hasScrolledHalfway = true;
    CustomLandingPageEvent('article_halfway_viewed', page_info.landing_page.pretty_name, page_info.landing_page.variant_name).send();
  };

  $window
    .on('scroll', function() {
      onScrollBelowFold();
      onScrollHalfway();
    })
    .on('resize', function() {
      viewportHeight = $window.height();
    });
});
